export function checkNullorUndefined(obj: any) {
    return obj === null || obj === undefined ?  true : false;
}
